var _rect, _path, _g, _g2, _circle, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2384,
    height: 598,
    viewBox: "0 0 2384 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2771_15206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 23,
    width: 2363,
    height: 569
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.6367,
    y: 23,
    width: 2362.36,
    height: 569,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2771_15206)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.333 225.465C631.635 203.489 745.031 41.1413 1129.51 107.667C1513.99 174.192 1631.29 23.0013 1970.16 23C2309.03 22.9987 2385.64 182 2385.64 182L2385.64 593L18.3633 593L18.3633 197C18.3633 197 95.0299 247.441 363.333 225.465Z",
    fill: "url(#paint0_linear_2771_15206)",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2771_15206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 55,
    width: 2356,
    height: 537
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_2771_15206_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1959.55 55.7793C2127.93 55.7787 2232.09 103.303 2294.14 150.786C2325.17 174.53 2345.68 198.271 2358.43 216.069C2364.81 224.968 2369.24 232.381 2372.08 237.566C2373.5 240.159 2374.52 242.195 2375.19 243.58C2375.52 244.273 2375.76 244.803 2375.92 245.159C2376 245.337 2376.06 245.472 2376.1 245.562C2376.11 245.579 2376.11 245.595 2376.12 245.608L2383.49 591.45L28.9453 591.45L28.9453 205.3C28.9587 205.308 28.9716 205.318 28.9854 205.327C29.5463 205.689 30.4 206.213 31.5781 206.871C33.9345 208.187 37.5908 210.036 42.8076 212.183C53.2414 216.477 69.9188 221.963 94.9297 226.759C144.95 236.35 228.312 243.18 361.745 232.181C495.222 221.177 590.221 175.02 699.481 139.996C808.751 104.969 932.442 81.0079 1123.51 114.281C1314.76 147.584 1439.56 132.95 1558.68 109.992C1677.78 87.0367 1791.12 55.7799 1959.55 55.7793Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1959.55 55.7793C2127.93 55.7787 2232.09 103.303 2294.14 150.786C2325.17 174.53 2345.68 198.271 2358.43 216.069C2364.81 224.968 2369.24 232.381 2372.08 237.566C2373.5 240.159 2374.52 242.195 2375.19 243.58C2375.52 244.273 2375.76 244.803 2375.92 245.159C2376 245.337 2376.06 245.472 2376.1 245.562C2376.11 245.579 2376.11 245.595 2376.12 245.608L2383.49 591.45L28.9453 591.45L28.9453 205.3C28.9587 205.308 28.9716 205.318 28.9854 205.327C29.5463 205.689 30.4 206.213 31.5781 206.871C33.9345 208.187 37.5908 210.036 42.8076 212.183C53.2414 216.477 69.9188 221.963 94.9297 226.759C144.95 236.35 228.312 243.18 361.745 232.181C495.222 221.177 590.221 175.02 699.481 139.996C808.751 104.969 932.442 81.0079 1123.51 114.281C1314.76 147.584 1439.56 132.95 1558.68 109.992C1677.78 87.0367 1791.12 55.7799 1959.55 55.7793Z",
    stroke: "white",
    strokeOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1959.55 55.7793C2127.93 55.7787 2232.09 103.303 2294.14 150.786C2325.17 174.53 2345.68 198.271 2358.43 216.069C2364.81 224.968 2369.24 232.381 2372.08 237.566C2373.5 240.159 2374.52 242.195 2375.19 243.58C2375.52 244.273 2375.76 244.803 2375.92 245.159C2376 245.337 2376.06 245.472 2376.1 245.562C2376.11 245.579 2376.11 245.595 2376.12 245.608L2383.49 591.45L28.9453 591.45L28.9453 205.3C28.9587 205.308 28.9716 205.318 28.9854 205.327C29.5463 205.689 30.4 206.213 31.5781 206.871C33.9345 208.187 37.5908 210.036 42.8076 212.183C53.2414 216.477 69.9188 221.963 94.9297 226.759C144.95 236.35 228.312 243.18 361.745 232.181C495.222 221.177 590.221 175.02 699.481 139.996C808.751 104.969 932.442 81.0079 1123.51 114.281C1314.76 147.584 1439.56 132.95 1558.68 109.992C1677.78 87.0367 1791.12 55.7799 1959.55 55.7793Z",
    stroke: "url(#paint1_linear_2771_15206)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2771_15206)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2771_15206)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 790.5,
    cy: 790.5,
    r: 790.5,
    transform: "matrix(0.896251 0.443548 -0.799695 0.600407 1995.09 -396.325)",
    fill: "url(#paint2_linear_2771_15206)",
    fillOpacity: 0.05
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2771_15206)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint3_angular_2771_15206_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.542456 0.268457 -0.484015 0.363396 1857.3 416.346)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1002.48,
    y: -1002.48,
    width: 2004.96,
    height: 2004.96
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(41, 139, 201, 1) 0deg,rgba(135, 162, 199, 1) 97.0608deg,rgba(0, 98, 232, 1) 181.478deg,rgba(37, 138, 202, 1) 220.621deg,rgba(47, 111, 227, 1) 267.566deg,rgba(37, 138, 202, 1) 355.293deg,rgba(41, 139, 201, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 605.25,
    cy: 605.25,
    r: 605.25,
    transform: "matrix(0.896251 0.443548 -0.799695 0.600407 1798.86 -215.507)",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.53200417757034302,\"g\":0.63760507106781006,\"b\":0.78111368417739868,\"a\":1.0},\"position\":0.26961320638656616},{\"color\":{\"r\":0.0,\"g\":0.38682061433792114,\"b\":0.91250002384185791,\"a\":1.0},\"position\":0.50410437583923340},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.61283665895462036},{\"color\":{\"r\":0.18521772325038910,\"g\":0.43767693638801575,\"b\":0.89272087812423706,\"a\":1.0},\"position\":0.74323785305023193},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.98692411184310913}],\"stopsVar\":[{\"color\":{\"r\":0.53200417757034302,\"g\":0.63760507106781006,\"b\":0.78111368417739868,\"a\":1.0},\"position\":0.26961320638656616},{\"color\":{\"r\":0.0,\"g\":0.38682061433792114,\"b\":0.91250002384185791,\"a\":1.0},\"position\":0.50410437583923340},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.61283665895462036},{\"color\":{\"r\":0.18521772325038910,\"g\":0.43767693638801575,\"b\":0.89272087812423706,\"a\":1.0},\"position\":0.74323785305023193},{\"color\":{\"r\":0.14509804546833038,\"g\":0.54117649793624878,\"b\":0.79215687513351440,\"a\":1.0},\"position\":0.98692411184310913}],\"transform\":{\"m00\":1084.911621093750,\"m01\":-968.03070068359375,\"m02\":1798.8593750,\"m10\":536.9143066406250,\"m11\":726.79217529296875,\"m12\":-215.50683593750},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 11.9062,
    y: 51,
    width: 2376.09,
    height: 547.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_1_2771_15206_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1966.88 55.5C2135.28 55.4994 2239.46 103.053 2301.51 150.565C2332.55 174.324 2353.06 198.079 2365.81 215.888C2372.18 224.792 2376.62 232.21 2379.46 237.398C2380.88 239.993 2381.9 242.03 2382.57 243.416C2382.9 244.109 2383.14 244.64 2383.3 244.996C2383.38 245.174 2383.44 245.309 2383.48 245.398C2383.49 245.413 2383.49 245.427 2383.5 245.439L2383.5 594L22.1289 594L16.418 204.346C16.507 204.393 16.603 204.446 16.708 204.5C17.411 204.865 18.4738 205.395 19.9189 206.061C22.8091 207.392 27.2298 209.265 33.3652 211.442C45.6365 215.798 64.7676 221.37 92.2354 226.251C147.171 236.014 235.455 243.016 368.905 232.01C502.397 221 597.405 174.814 706.678 139.769C815.96 104.72 939.664 80.7434 1130.76 114.037C1322.02 147.36 1446.84 132.718 1565.97 109.746C1685.09 86.7765 1798.44 55.5007 1966.88 55.5Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1966.88 55.5C2135.28 55.4994 2239.46 103.053 2301.51 150.565C2332.55 174.324 2353.06 198.079 2365.81 215.888C2372.18 224.792 2376.62 232.21 2379.46 237.398C2380.88 239.993 2381.9 242.03 2382.57 243.416C2382.9 244.109 2383.14 244.64 2383.3 244.996C2383.38 245.174 2383.44 245.309 2383.48 245.398C2383.49 245.413 2383.49 245.427 2383.5 245.439L2383.5 594L22.1289 594L16.418 204.346C16.507 204.393 16.603 204.446 16.708 204.5C17.411 204.865 18.4738 205.395 19.9189 206.061C22.8091 207.392 27.2298 209.265 33.3652 211.442C45.6365 215.798 64.7676 221.37 92.2354 226.251C147.171 236.014 235.455 243.016 368.905 232.01C502.397 221 597.405 174.814 706.678 139.769C815.96 104.72 939.664 80.7434 1130.76 114.037C1322.02 147.36 1446.84 132.718 1565.97 109.746C1685.09 86.7765 1798.44 55.5007 1966.88 55.5Z",
    stroke: "white",
    strokeOpacity: 0.07
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1966.88 55.5C2135.28 55.4994 2239.46 103.053 2301.51 150.565C2332.55 174.324 2353.06 198.079 2365.81 215.888C2372.18 224.792 2376.62 232.21 2379.46 237.398C2380.88 239.993 2381.9 242.03 2382.57 243.416C2382.9 244.109 2383.14 244.64 2383.3 244.996C2383.38 245.174 2383.44 245.309 2383.48 245.398C2383.49 245.413 2383.49 245.427 2383.5 245.439L2383.5 594L22.1289 594L16.418 204.346C16.507 204.393 16.603 204.446 16.708 204.5C17.411 204.865 18.4738 205.395 19.9189 206.061C22.8091 207.392 27.2298 209.265 33.3652 211.442C45.6365 215.798 64.7676 221.37 92.2354 226.251C147.171 236.014 235.455 243.016 368.905 232.01C502.397 221 597.405 174.814 706.678 139.769C815.96 104.72 939.664 80.7434 1130.76 114.037C1322.02 147.36 1446.84 132.718 1565.97 109.746C1685.09 86.7765 1798.44 55.5007 1966.88 55.5Z",
    stroke: "url(#paint4_linear_2771_15206)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315.711 610.821C578.735 597.051 645.486 552.918 968.542 569.276C1291.6 585.635 1697.68 489.925 1962.02 487.146C2226.36 484.368 2362.3 504.65 2470.92 570.06L2470.92 619.498L114.436 637.153L114.412 619.498C114.412 619.498 52.687 624.59 315.711 610.821Z",
    fill: "url(#paint5_linear_2771_15206)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2771_15206_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1959.55 55.7793C2127.93 55.7787 2232.09 103.303 2294.14 150.786C2325.17 174.53 2345.68 198.271 2358.43 216.069C2364.81 224.968 2369.24 232.381 2372.08 237.566C2373.5 240.159 2374.52 242.195 2375.19 243.58C2375.52 244.273 2375.76 244.803 2375.92 245.159C2376 245.337 2376.06 245.472 2376.1 245.562C2376.11 245.579 2376.11 245.595 2376.12 245.608L2383.49 591.45L28.9453 591.45L28.9453 205.3C28.9587 205.308 28.9716 205.318 28.9854 205.327C29.5463 205.689 30.4 206.213 31.5781 206.871C33.9345 208.187 37.5908 210.036 42.8076 212.183C53.2414 216.477 69.9188 221.963 94.9297 226.759C144.95 236.35 228.312 243.18 361.745 232.181C495.222 221.177 590.221 175.02 699.481 139.996C808.751 104.969 932.442 81.0079 1123.51 114.281C1314.76 147.584 1439.56 132.95 1558.68 109.992C1677.78 87.0367 1791.12 55.7799 1959.55 55.7793Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2771_15206",
    x: 821.889,
    y: -461.205,
    width: 2499.05,
    height: 1780.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_2771_15206"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2771_15206",
    x: 530.293,
    y: -635.485,
    width: 2654.01,
    height: 2103.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 300,
    result: "effect1_foregroundBlur_2771_15206"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint3_angular_2771_15206_clip_path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 605.25,
    cy: 605.25,
    r: 605.25,
    transform: "matrix(0.896251 0.443548 -0.799695 0.600407 1798.86 -215.507)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_2771_15206_clip_path",
    transform: "translate(-11.9062 -51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1966.88 55.5C2135.28 55.4994 2239.46 103.053 2301.51 150.565C2332.55 174.324 2353.06 198.079 2365.81 215.888C2372.18 224.792 2376.62 232.21 2379.46 237.398C2380.88 239.993 2381.9 242.03 2382.57 243.416C2382.9 244.109 2383.14 244.64 2383.3 244.996C2383.38 245.174 2383.44 245.309 2383.48 245.398C2383.49 245.413 2383.49 245.427 2383.5 245.439L2383.5 594L22.1289 594L16.418 204.346C16.507 204.393 16.603 204.446 16.708 204.5C17.411 204.865 18.4738 205.395 19.9189 206.061C22.8091 207.392 27.2298 209.265 33.3652 211.442C45.6365 215.798 64.7676 221.37 92.2354 226.251C147.171 236.014 235.455 243.016 368.905 232.01C502.397 221 597.405 174.814 706.678 139.769C815.96 104.72 939.664 80.7434 1130.76 114.037C1322.02 147.36 1446.84 132.718 1565.97 109.746C1685.09 86.7765 1798.44 55.5007 1966.88 55.5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2771_15206",
    x1: 1142.38,
    y1: 23,
    x2: 1142.38,
    y2: 418.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#258ACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2771_15206",
    x1: 919.139,
    y1: 427.523,
    x2: 998.938,
    y2: -68.5661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2771_15206",
    x1: -0.0000162955,
    y1: 0.00111161,
    x2: 1908.43,
    y2: 788.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44009B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2370CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2771_15206",
    x1: 911.341,
    y1: 429.206,
    x2: 991.557,
    y2: -69.4995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2771_15206",
    x1: 1263.48,
    y1: 426.888,
    x2: 1249.07,
    y2: 628.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#258ACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg);
export default __webpack_public_path__ + "static/media/footerBg.94cb43c77e0972d754cf4cba0ae1c001.svg";
export { ForwardRef as ReactComponent };